import { APP_BASE_HREF } from '@angular/common';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { localizedMeta, MetaService } from '@planone/shared/util-meta';
import { combineLatestWith, tap } from 'rxjs';

import * as DataAccessPostsPageActions from './data-access-posts.page.actions';

import { DataAccessPostsFacade } from '../../posts/entity/data-access-posts.facade';

@Injectable()
export class DataAccessPostsPageEffects {
  setTitle$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DataAccessPostsPageActions.postsPageView),
        combineLatestWith(this.PostFacade.post$),
        tap(([_, post]) => {
          if (post) {
            this.metaService.setTitle(localizedMeta['titlePostDetails'], [post.headline ?? '']);
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private PostFacade: DataAccessPostsFacade,
    private metaService: MetaService,
    @Inject(LOCALE_ID) private locale: string,
    @Inject(APP_BASE_HREF) private baseHref: string
  ) {}
}
